import React from 'react';
import './FilterChipWrapperComponentStyles.scss';

const FilterChipWrapperComponent = (props: any): React.ReactElement => {
  const {children} = props;

  return <div className={'filter-chip-drawer-content-section'}>{children}</div>;
};

export default FilterChipWrapperComponent;
